import React from 'react';
import { CounterInfoField } from './CounterInfoField';

type InfoFieldWithCounterProps = {
  label: string;
  value: string | React.ReactNode;
  counterValue?: string | React.ReactNode;
  className?: string;
  valueColor?: string;
  size?: 'default' | 'large';
};

export const InfoFieldWithCounter: React.FC<InfoFieldWithCounterProps> = ({
  label,
  value,
  counterValue,
  className,
  valueColor,
  size = 'default',
}) => {
  const labelClass = size === 'large' ? 'text-sm text-gray-600' : 'text-sm font-medium break-words text-[#B2B2B2]';
  const valueClass =
    size === 'large'
      ? `${valueColor || 'text-black'} text-xl font-semibold break-words`
      : `${valueColor || 'text-black'} text-base font-medium break-words`;
  const gapClass = size === 'large' ? 'gap-1' : 'gap-2';

  return (
    <div className={`flex flex-col justify-start items-start ${gapClass} ${className}`}>
      <div
        className={labelClass}
        style={{
          fontFamily: 'var(--ep-font-avenir)',
        }}
      >
        {label}
      </div>
      <div className="flex items-center gap-2">
        <div
          className={valueClass}
          style={{
            fontFamily: 'var(--ep-font-avenir)',
          }}
        >
          {value}
        </div>
        {counterValue && <CounterInfoField value={counterValue} color={valueColor} />}
      </div>
    </div>
  );
};
